<div
  class="rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary px-3 py-2.5 space-y-2">
  <div class="flex items-center gap-3">
    <span
      class="w-7 h-7 rounded-lg bg-gray-200 dark:bg-dark-secondary flex items-center justify-center shrink-0">
      <span class="material-symbols-rounded text-base text-gray-500 dark:text-dark-muted">notes</span>
    </span>
    <span class="flex-1 text-[13px] font-semibold text-gray-900 dark:text-dark-text">{{
      TEXT.TRANSACTIONS.DESCRIPTION }}</span>
    <button type="button" (click)="remove.emit()"
      class="w-7 h-7 rounded-full hover:bg-white dark:hover:bg-dark-secondary text-gray-400 inline-flex items-center justify-center shrink-0 transition-colors">
      <span class="material-symbols-rounded text-base">close</span>
    </button>
  </div>
  <textarea [formControl]="fc" rows="2"
    class="w-full px-3 py-2 border border-neutral-border dark:border-dark-border rounded-xl bg-white dark:bg-dark-secondary text-sm text-gray-900 dark:text-dark-text placeholder:text-gray-400 dark:placeholder:text-dark-muted outline-none focus:ring-2 focus:ring-brand-primary/40 transition-shadow resize-none"
    [placeholder]="placeholder" (input)="change.emit()"></textarea>
</div>
